import containerItem from "./container.js"
import imageElement from "../element/image.js"
import compositionBuild from "./compositionBuild.js"
import planBase from "./plan/planBase.js";
import base from "../base.js";
import printStyleDefinition from "../definition/printStyle.js";
import printSize from "../definition/printSize.js";
import printOrientation from "../definition/printOrientation.js";
import rotationDefinition from "../definition/rotation.js";

export default class Composition extends base {
    objectType = "CompositionItem";
    siteId = null;
    _name = null;
    description = null;
    Enable = true;
    _PrintPapers = null;// string
    PrintStyle = [];//list string
    _PrintOrientation = "PORTRAIT";//string
    Thumbnail = null;//class media
    LiveTimeout = 60;
    Live = null//class ContainerItem
    Build = null;
    
    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }

    objectToClassValue(args = {}) {
        let thumbnail = null;
        args = this.constructor.fromObjectToObject(args);
        if (args.thumbnail) {
            thumbnail = imageElement.fromObject(args.thumbnail);
        }
        else {
            thumbnail = imageElement.fromObject({});
        }
        args.thumbnail = thumbnail;
        if (args.live)
            args.live = containerItem.fromObject(args?.live);
        else {
            args.live = containerItem.fromObject({
                position: args.position,
                canAddElement: false,
                contents: [{ objectType: "DynamicImage", canBeRemove: false, rotation: "RotateNoneFlipX" }]
            });
        }
        if (args.build)
            args.build = compositionBuild.fromObject(args.build);
        else
            args.build = compositionBuild.fromObject({});
        super.objectToClassValue(args);
        this.Enable = args.enable ? args.enable : true;
        if (args.printPapers && !args.printStyle) {
            let re = new RegExp(/^(_\d+x\d+_)(GLOSSY|MAT)$/);
            args.printPapers.forEach(paper => {
                let match = paper.match(re);
                if (match) {
                    if (this._PrintPapers == null)
                        this._PrintPapers = this.getIdFromText(match[1], printSize);
                    else {
                        let f = printSize.find(el => el.name == match[1]);
                        let s = printSize.find(el => el.name == this.PrintPapers);
                        if (f.width > s.width)
                            this._PrintPapers = this.getIdFromText(match[1], printSize);
                    }
                    this.PrintStyle.push(this.getIdFromText(match[2], printStyleDefinition));
                }
            });
        }
        else {
            this._PrintPapers = args.printPapers ? this.getIdFromText(args.printPapers, printSize) : null;
            this.PrintStyle = args.printStyle && args.printStyle.length > 0 ? args.printStyle.map(el => this.getIdFromText(el, printStyleDefinition)) : [];
        }
        if (this._PrintPapers == null) {
            this._PrintPapers = this.getIdFromText("_4x6_", printSize);
        }
        if (this.PrintStyle.length == 0) {
            this.PrintStyle.push(this.getIdFromText("GLOSSY", printStyleDefinition));
        }
        this.LiveTimeout = args.liveTimeout ? args.liveTimeout : 60;
        this.Thumbnail = args.thumbnail ? args.thumbnail : null;
        if (this.Thumbnail) {
            this.Thumbnail.CanChangeName = false;
            this.Thumbnail.parent = this;
            this.Thumbnail.CanBeRemove = false;
            this.Thumbnail.id = this.id;
        }
        this.Thumbnail.CanBeHide = false;
        this.Build = args.build;
        if (this.Build == null) {
            this.Build = new compositionBuild();
        }
        this.Build.parent = this;
        this.Build.Name = this.Name;
        if (this.Build.Size) {
            if (this.Build.Size.width > this.Build.Size.height) {
                this._PrintOrientation = this.getIdFromText("LANDSCAPE", printOrientation);
            }
            else {
                this._PrintOrientation = this.getIdFromText("PORTRAIT", printOrientation);
            }
        }
        this.siteId = args.siteId ? args.siteId : null;
        this.description = args.description ? args.description : null;
        this.Name = args.name ? args.name : null;
        this.Live = args.live;
        this.Live.parent = this;
        this.Live.Show = false;
        this.Live.CanChangeName = false;
        this.Live.CanBeRemove = false;
        if (!this.Live._name || this.Live.Name == this.Live.constructor.Name)
            this.Live.Name = this.Name;
        this.Live.Contents.forEach(el => {
            el.CanBeRemove = false;
            el.id = this.id;
        });
        this.updateBuildSize();
    }
    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "Live", construct: containerItem, jsType: "Class" },
            { property: "Build", construct: compositionBuild, jsType: "Class" },
            { property: "PrintPapers", construct: String, jsType: "String" },
            { property: "PrintStyle", construct: String, jsType: "Array" },
            { property: "PrintOrientation", construct: String, jsType: "String" },
            { property: "Thumbnail", construct: imageElement, jsType: "Class", ignoreOnExport: true },
            { property: "LiveTimeout", construct: Number, jsType: "Number" },
            { property: "Enable", construct: Boolean, jsType: "Boolean" },
        ];
    }
    get Name() {
        return this._name;
    }
    set Name(value) {
        this._name = value;
        if (this.Build) {
            this.Build.Name = value;
        }
        if (this.Thumbnail) {
            this.Thumbnail.Name = value;
        }
    }
    get PrintPapersSize() {
        let f = printSize.find(el => el.idSoft == this.PrintPapers);
        if (f) {
            let o = printOrientation.find(el => el.idSoft == this.PrintOrientation);
            if (o) {
                return {
                    width: o.width == -1 ? Math.min(f.width, f.height) : Math.max(f.width, f.height),
                    height: o.width == -1 ? Math.max(f.width, f.height) : Math.min(f.width, f.height),
                    widthCM: o.width == -1 ? Math.min(f.widthCM, f.heightCM) : Math.max(f.widthCM, f.heightCM),
                    heightCM: o.width == -1 ? Math.max(f.widthCM, f.heightCM) : Math.min(f.widthCM, f.heightCM),
                    ratio: o.width == -1 ? f.ratio : 1 / f.ratio
                };
            }
        }
        return {
            width: 0,
            height: 0,
            widthCM: 0,
            heightCM: 0,
            ratio: 0
        };
    }

    get PrintStyleName() {
        return this.PrintStyle.map(printStyle => printStyleDefinition.find(el => el.idSoft == printStyle).name);
    }

    get PrintOrientationName() {
        return printOrientation.find(el => el.idSoft == this._PrintOrientation).name;
    }

    get PrintOrientation() {
        return this._PrintOrientation;
    }
    set PrintOrientation(value) {
        if (this.updateBuildSize(this.PrintPapers, value) == true) {
            this._PrintOrientation = value;
        }
    }

    get PrintPapersName() {
        return printSize.find(el => el.idSoft == this._PrintPapers).name;
    }

    get PrintPapers() {
        return this._PrintPapers;
    }
    set PrintPapers(value) {
        if (this.updateBuildSize(value, this.PrintOrientation) == true) {
            this._PrintPapers = value;
        }
    }
    get imagePath() {
        if (this.Thumbnail && this.Thumbnail.objectType == "ImageElement") {
            return this.Thumbnail.Path;
        }
        return "";
    }
    static get Name() {
        return "Composition";
    }
    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { text: "Nom", name: "Name", type: "textInput", dataType: "string" },
            { text: "Finitions d'impression", name: "PrintStyle", type: "selectInput", dataType: "string", options: printStyleDefinition, optionsType: "idSoft", multiple: true },
            { text: "Type de papier", name: "PrintPapers", type: "selectInput", dataType: "string", options: printSize, optionsType: "idSoft" },
            { text: "Orientation d'impression", name: "PrintOrientation", type: "selectInput", dataType: "string", options: printOrientation, optionsType: "idSoft" },
            // { name: "Enable", type: "booleanInput", dataType: "boolean" },
            { text: "Temps maximum pour la prise photo", name: "LiveTimeout", type: "numberInput", dataType: "number", tooltip: "Temps maximum pour la prise photo en secondes, une fois ce temps passé, la prise photo s'arrête dans le logiciel" },
            { text: "Image de présentation", name: "Thumbnail", type: "objectInput", dataType: "object", options: imageElement, tooltip: "Image de présentation de la composition, elle sera affichée sur la page de sélection de la composition" },
            // { name: "Live", type: "objectInput", dataType: "object", options: containerItem },
            { text: "Plans", name: "Build.Plans", type: "arrayInput", dataType: "object", options: planBase, elementOption: "compositionElement" },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }
    updateBuildSize(printPapers = null, printO = null) {
        let f = null;
        if (printPapers == null) {
            f = printSize.find(el => el.idSoft == this.PrintPapers);
        }
        else {
            f = printSize.find(el => el.idSoft == printPapers);
        }
        if (f) {
            let o = null;
            if (printO == null) {
                o = printOrientation.find(el => el.idSoft == this._PrintOrientation);
            }
            else {
                o = printOrientation.find(el => el.idSoft == printO);
            }
            if (o) {
                if (o.width == -1) {
                    this.Build.UpdateSize(Math.min(f.width, f.height), Math.max(f.width, f.height));
                }
                else {
                    this.Build.UpdateSize(Math.max(f.width, f.height), Math.min(f.width, f.height));
                }
            }
            else {
                this.Build.UpdateSize(f.width, f.height);
            }
            return true;
        }
        return false;
    }
    getCompositionElementById(id) {
        if (this.Build) {
            return this.Build.getCompositionElementById(id);
        }
        return null;
    }
    swapArrayElement(index, move) {
        if (index < 0 || index > this.Contain.length) return;
        this.Contain.splice(index + move, 0, this.Contain.splice(index, 1)[0]);
    }
    getStyle(currentElementIndex = null) {
        return {
            ...super.getStyle(currentElementIndex),
        };
    }
    removeFromBuild(previewId) {
        if (this.Build) {
            this.Build.removeFromBuild(previewId);
        }
    }
    static fromObject(object = {}) {
        return new this.prototype.constructor(object);
    }
    addToBuild(element) {
        if (this.Build == null) {
            this.Build = new compositionBuild();
        }
        this.Build.Plans.push(element);
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            printPapers: this.PrintStyle.map((s) => {
                return this.PrintPapersName + printStyleDefinition.find(el => el.idSoft == s).name
            }),
            enable: this.Enable,
            // thumbnail: this.Thumbnail ? this.Thumbnail.toExportObject(variableArray, ressourceArray) : null,
            liveTimeout: this.LiveTimeout,
            build: this.Build ? this.Build.toExportObject(variableArray, ressourceArray) : null,
        }
    }
    toObject(minify = false) {
        let obj = {
            ...super.toObject(minify),
            enable: this.Enable,
            printPapers: this.PrintPapers ? this.PrintPapersName : [],
            printStyle: this.PrintStyle.length > 0 ? this.PrintStyleName : [],
            thumbnail: this.Thumbnail ? this.Thumbnail.toObject(minify) : null,
            liveTimeout: this.LiveTimeout,
            live: this.Live ? this.Live.toObject(minify) : null,
            build: this.Build ? this.Build.toObject(minify) : null,
            name: this.Name,
        }
        if (minify == false) {
            obj.siteId = this.siteId;
            obj.description = this.description;
        }
        return obj;
    }
    getFromPreviewId(id) {
        if (super.hasPreviewId(id) == true)
            return this;
        if (this.Thumbnail) {
            let result = this.Thumbnail.getFromPreviewId(id);
            if (result != null)
                return result;
        }
        if (this.Live != null) {
            return this.Live.getFromPreviewId(id);
        }
        return null;
    }
    checkIsComplete() {
        let result = {
            isComplete: true,
            requiredBeforeSave: false,
            missingElements: []
        };
        if (this.Name == null) {
            result.isComplete = false;
            result.requiredBeforeSave = true;
            result.missingElements.push("Nom");
        }
        if (this.PrintStyle.length == 0) {
            result.isComplete = false;
            result.requiredBeforeSave = true;
            result.missingElements.push("Finitions d'impression");
        }
        if (this.PrintPapers == null) {
            result.isComplete = false;
            result.requiredBeforeSave = true;
            result.missingElements.push("Type de papier");
        }
        if (this.PrintOrientation == null) {
            result.isComplete = false;
            result.requiredBeforeSave = true;
            result.missingElements.push("Orientation d'impression");
        }
        if (this.LiveTimeout == null) {
            result.isComplete = false;
            result.requiredBeforeSave = true;
            result.missingElements.push("Temps maximum pour la prise photo");
        }
        if (this.Thumbnail == null || !this.Thumbnail._Path) {
            result.isComplete = false;
            result.requiredBeforeSave = true;
            result.missingElements.push("Image de présentation");
        }
        if (this.Build == null) {
            result.isComplete = false;
            result.requiredBeforeSave = true;
            result.missingElements.push("Composition vide");
        }
        else {
            result = this.Build.checkIsComplete(result);
        }
        return result;
    }
}
